import {createReducer} from '@reduxjs/toolkit';

import {TOURS, TOUR_STEPS} from '@explorer/constants/tour';
import {resetTour, runTour, setTour, setTourIndex} from '../actions/tour.js';

const mainTour = TOURS.MAIN;

export const initialState = {
  run: false,
  index: 0,
  tour: mainTour,
  steps: TOUR_STEPS[mainTour],
};

const tour = createReducer(initialState, builder => {
  builder.addCase(runTour, (state, {payload}) => {
    state.run = payload;
  });

  builder.addCase(setTour, (state, {payload}) => {
    const tour = payload ? payload : mainTour;
    state.tour = tour;
    state.index = 0;
    state.steps = TOUR_STEPS[tour];
    state.run = true;
  });

  builder.addCase(setTourIndex, (state, {payload: index}) => {
    state.index = index;
  });

  builder.addCase(resetTour, () => initialState);
});

export default tour;
